/* eslint-disable react/no-array-index-key, no-underscore-dangle, no-unused-vars */
import React, { useEffect, useState } from 'react';
import Image from 'next/image';

import { FRONTEND_DOMAIN } from '../../constants/api';
import { phpApi } from '../../utils/AxiosInstance';

import styles from '../../styles/timebase-testseries.module.scss';

function Exploretest() {
  const [cateData, setCatData] = useState([]);
  let slug = '';
  if (FRONTEND_DOMAIN === 'https://www.studyiq.com') {
    slug = 'mock-test-series';
  } else {
    slug = 'testseries';
  }
  const getCatData = async () => {
    const response = await phpApi.get(`get_menu_section?menu_slug=${slug}`);
    if (response?.data?.success) {
      setCatData(response.data?.data);
    } else {
      setCatData([]);
    }
  };

  useEffect(() => {
    getCatData();
  }, []);

  const courseTypeClick = (elem) => {
    window.open(`${FRONTEND_DOMAIN}/course-detail/${elem?.course_slug}`, '_self');
  };

  return (
    <>
      {cateData?.sections?.length > 0 && <div className={styles.testTitle}>Explore our Test Series</div>}
      {cateData?.sections?.map((elem) => (
        <div key={elem?._section_id}>
          <div className={styles.courseHeading}>{elem?.section_name}</div>
          <div className={styles.row4}>
            {elem.courses.map((e, i) => (
              <div className={styles.column4} key={i} onClick={() => courseTypeClick(e)}>
                <div className={styles.imageWrapper}>
                  {e?.thumbnail_url ? (
                    <Image
                      src={`${e?.thumbnail_url}`}
                      width={240}
                      height={157}
                      className={styles.productImg}
                      alt="Product"
                    />
                  ) : (
                    <div className={styles.noProductImage}>No Image</div>
                  )}
                </div>
                <div className={styles.productText}>{e?.display_course_name}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
      <div className={styles.mobileView}>
        {cateData?.sections?.map((elem) => (
          <div key={elem?._section_id}>
            <div className={styles.courseheadingmobile}>{elem?.section_name}</div>
            <div className={styles.row4}>
              {elem.courses.map((e, i) => (
                <div key={i} className={styles.column4} onClick={() => courseTypeClick(e)}>
                  <div className={styles.imageWrapper}>
                    {e?.thumbnail_url ? (
                      <Image
                        src={`${e?.thumbnail_url}`}
                        width={158}
                        height={106}
                        className={styles.productImg}
                        alt="Product"
                      />
                    ) : (
                      <div className={styles.noProductImage}>No Image</div>
                    )}
                  </div>
                  <div className={styles.productText}>{e?.display_course_name}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Exploretest;
